import { Navigate, Outlet, useLocation } from "react-router-dom";
import { localStorageInstance } from "../../utils/storage";

const Private = () => {
  console.log("Private Route");
  const location = useLocation();

  const currentUrl = `${location.pathname}${location.search}`;

  const auth = localStorageInstance.getItem("token");
  console.log("Private Route:- " , auth)

  localStorageInstance.setItem("redirectLocation", currentUrl );
  return auth ? <Outlet /> : <Navigate to="/login" />;
};

export default Private;
